<script setup lang="ts">
import type { PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
interface Props {
    sale: PlatformSaleItemEntity;
}

const { sale } = defineProps<Props>();

// COMPOSABLES
const { isMonoVersion } = useSaleType(() => sale.type);
</script>

<template>
    <template v-if="isMonoVersion">
        <SdpMaybeTrustReportWrapper :sale="sale">
            <SdpSpecs :sale="sale" />
            <SdpDetails :sale="sale" />
            <SdpDocuments :asset="sale.mainAsset" :sale="sale" />
        </SdpMaybeTrustReportWrapper>

        <MktgTrustReport />
    </template>

    <SdpMultiGrid v-else :sale="sale" />
</template>
